module.exports = __webpack_public_path__ + "img/fireworks.654b61e5.svg";